import { AppInstallError } from '@atlassian/mpac-spi';
export let ErrorCode = /*#__PURE__*/function (ErrorCode) {
  ErrorCode["InvalidInstallationTargetInfo"] = "InvalidInstallationTargetInfo";
  ErrorCode["FallbackStoreBFFErrorCode"] = "UnknownErrorInMarketplaceStoreAppInstall";
  ErrorCode["AppAlreadyProvisioned"] = "APP_ALREADY_PROVISIONED";
  ErrorCode["GraphQLFetchError"] = "GraphQLFetchError";
  return ErrorCode;
}({});
const appendTaskId = (message, taskId) => {
  if (taskId) {
    return "".concat(message, " [taskId: ").concat(taskId, "]");
  }
  return message;
};

/**
 * The generic error thrown if there was a Fetch error (network, auth or other client side issue)
 */
export const appInstallErrorFromGraphQLFetchError = (appKey, operation, source, taskId) => {
  const message = operation === 'trigger' ? "Failed to trigger installation for app with key ".concat(appKey) : "Unknown error getting installation status for app with key ".concat(appKey);
  throw new AppInstallError({
    addon: {
      key: appKey
    },
    code: ErrorCode.GraphQLFetchError,
    message: appendTaskId(message, taskId),
    source
  });
};

/**
 * The store BFF API returns a GraphQL error response when there is an error installing an app.
 * Which includes the information in the "errors" field of the response.
 * We transform this to the corresponding "AppInstallError" type.
 */
export const appInstallErrorFromGraphQLErrorResponse = (appKey, operation, errors, extensions, taskId) => {
  var _error$extensions, _extensions$gateway, _error$message;
  const error = errors === null || errors === void 0 ? void 0 : errors[0];
  const errorCode = (error === null || error === void 0 ? void 0 : (_error$extensions = error.extensions) === null || _error$extensions === void 0 ? void 0 : _error$extensions.code) || ErrorCode.FallbackStoreBFFErrorCode;
  const requestId = extensions === null || extensions === void 0 ? void 0 : (_extensions$gateway = extensions.gateway) === null || _extensions$gateway === void 0 ? void 0 : _extensions$gateway.request_id;
  const message = (_error$message = error === null || error === void 0 ? void 0 : error.message) !== null && _error$message !== void 0 ? _error$message : operation === 'trigger' ? "Error triggering installation for app with key ".concat(appKey) : "Error getting installation status for app with key ".concat(appKey);
  throw new AppInstallError({
    addon: {
      key: appKey
    },
    code: errorCode,
    message: appendTaskId(message, taskId),
    source: error,
    requestId
  });
};